/* global axios */

import ApiClient from './ApiClient';

class KaptionAccessTokensAPI extends ApiClient {
  constructor() {
    super('kaption_access_tokens', { accountScoped: true });
  }

  getAll(params = {}) {
    return axios.get(this.url, { params });
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  revoke(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  rotate(id) {
    return axios.post(`${this.url}/${id}/rotate`);
  }

  getKaptionAssistants() {
    return axios.get(`${this.url}/kaption_assistants`);
  }

  getScopes() {
    return axios.get(`${this.url}/scopes`);
  }
}

export default new KaptionAccessTokensAPI();
